import { useEffect, useState } from 'react';
import { api } from '@/lib/api.ts';
import { nativeBridge } from '@/lib/native.ts';

/**
 * "There is a newer app on the server."
 *
 * ONLY INSIDE THE WRAPPER, and only when the server's build is genuinely
 * newer. A browser updates itself by reloading; it has nothing to install and
 * nothing to be told.
 *
 * The APK is sideloaded, so no store will ever tell it anything. The only
 * party in a position to notice is the page it is already talking to — which
 * is why the check lives here rather than in Kotlin.
 *
 * Deliberately a NOTICE, not an installer. Android will not let an app
 * install an APK without a permission prompt and a trip through the package
 * installer, and a television app that starts asking for install rights is a
 * television app people should be suspicious of. Telling somebody the address
 * to type is honest and takes ten seconds.
 */
export function UpdateNotice() {
  const [newer, setNewer] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const bridge = nativeBridge();
    const mine = bridge?.appVersionCode?.();
    // No wrapper, or a wrapper too old to say — either way, nothing to offer.
    if (!mine) return;

    let live = true;
    void api.appVersion()
      .then((r) => {
        if (!live || !r.available || !r.versionCode) return;
        setNewer(r.versionCode > mine);
      })
      .catch(() => { /* an update check is never worth an error on screen */ });
    return () => { live = false; };
  }, []);

  if (!newer || dismissed) return null;

  return (
    <div className="update-notice" role="status">
      <strong>A newer N8Media is ready.</strong>
      {' '}Open Downloader on this television and enter{' '}
      <span className="update-url">{window.location.host}/app.apk</span>
      <button className="update-dismiss" onClick={() => setDismissed(true)}>Dismiss</button>
    </div>
  );
}
